import type { RiskInsightsSitesQueryArgs } from './riskInsightsEngineSlice';

export const buildSitesCacheTagId = (arg: RiskInsightsSitesQueryArgs): string =>
    [
        arg.businessCentralId,
        arg.page,
        arg.pageSize,
        arg.nameContains ?? '',
        arg.sortBy ?? '',
        arg.sortDir ?? '',
        (arg.isic ?? []).join(','),
        (arg.countries ?? []).join(','),
        (arg.physicalRiskLevels ?? []).join(','),
        (arg.dependencyLevels ?? []).join(','),
        (arg.impactLevels ?? []).join(','),
        (arg.sonLevels ?? []).join(','),
        arg.at ?? '',
    ].join(':');
